export default {
  movies:[],
  apiKey:process.env.VUE_APP_ENV_API_KEY
}